// components/section/YouTubeLiveStreamSection.tsx
import React from 'react';

interface YouTubeLiveStreamSectionProps {
  url: string;
}

const YouTubeLiveStreamSection: React.FC<YouTubeLiveStreamSectionProps> = ({ url }) => {
  const getYouTubeId = (url: string): string | null => {
     const standardMatch = url.match(/youtube\.com\/watch\?v=([a-zA-Z0-9_-]+)/);
      if (standardMatch && standardMatch[1]) {
        return standardMatch[1];
      }

      // Match live YouTube URLs (/live/)
      const liveMatch = url.match(/youtube\.com\/live\/([a-zA-Z0-9_-]+)/);
      if (liveMatch && liveMatch[1]) {
        return liveMatch[1];
      }

      // Match short URLs (youtu.be)
      const shortMatch = url.match(/youtu\.be\/([a-zA-Z0-9_-]+)/);
      if (shortMatch && shortMatch[1]) {
        return shortMatch[1];
      }

      return null;
  };

  const videoId = getYouTubeId(url);



  if (!videoId) return null;

  return (
    <div className="bg-white rounded-xl shadow-md overflow-hidden">
      <div className="p-4">
        <h2 className="text-xl font-bold text-gray-800 mb-3">Live Stream</h2>
        <div className="relative pb-[56.25%] h-0"> {/* 56.25% creates 16:9 aspect ratio */}
          <iframe
            src={`https://www.youtube.com/embed/${videoId}`}
            title="YouTube Live Stream"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
            className="absolute top-0 left-0 w-full h-full rounded-lg"
          />
        </div>
        <div className="mt-3 text-center">
          <a 
            href={url} 
            target="_blank" 
            rel="noopener noreferrer"
            className="inline-flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded-md shadow-sm text-white bg-red-600 hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-500"
          >
            Watch on YouTube
          </a>
        </div>
      </div>
    </div>
  );
};

export default YouTubeLiveStreamSection;